import React, { memo, useCallback } from 'react';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import PromptCard from '../PromptCard/PromptCard';
import SectionContainer from '../SectionContainer/SectionContainer';
import PromptEditorModal from '../PromptEditorModal/PromptEditorModal';
import ChatSmile2LineIcon from '../../../../design-system/Icons/ChatSmile2LineIcon';
import { Button } from '../../../../design-system';

const PromptsTab = ({ playbookId, prompts, setPlaybookDetail, isEditable }) => {
    const {
        isOpened: isCreateModalOpened,
        open: openCreateModal,
        close: closeCreateModal,
    } = useOverlayState();

    const setPrompts = useCallback(
        (cb) => {
            setPlaybookDetail((playbook) => ({ ...playbook, prompts: cb(playbook.prompts || []) }));
        },
        [setPlaybookDetail]
    );

    const arePrompts = !!prompts?.length;

    const renderButton = () => (
        <Button
            type="secondary"
            size="xs"
            text="New Prompt"
            leadingIcon={ChatSmile2LineIcon}
            onClick={openCreateModal}
        />
    );
    return (
        <SectionContainer
            title="Prompts"
            description="Prototype and develop AI use cases with prompts inside playbooks"
            isEditable={isEditable}
            renderButton={renderButton}
        >
            {arePrompts && (
                <ul className="flex flex-col gap-3">
                    {prompts.map((prompt) => (
                        <PromptCard
                            key={prompt.id}
                            prompt={prompt}
                            setPrompts={setPrompts}
                            isEditable={isEditable}
                        />
                    ))}
                </ul>
            )}

            {!arePrompts && (
                <p className="font-body-bold text-body-bold-s text-neutral-400">No prompts found</p>
            )}

            {isCreateModalOpened && (
                <PromptEditorModal
                    mode="create"
                    playbookId={playbookId}
                    setPrompts={setPrompts}
                    onClose={closeCreateModal}
                />
            )}
        </SectionContainer>
    );
};

export default memo(PromptsTab);
